import {
  REQUEST_QUOTE_DETAILS,
  RECEIVED_QUOTE_DETAILS,
  QUOTE_DETAILS_ERRORS,
  SET_REFERENCE_ID
} from '../actions/quote'

import { UPDATE_CURRENT_STEP } from '../actions/appState'

import { FORM_SUBMISSION_SUCCESS } from '../actions/forms'

const initialState = {
  isLoading: false,
  hasErrors: false,
  currentStep: 0,
  refId: null,
  errorStatus: null
}

const appState = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_QUOTE_DETAILS:
      return Object.assign({}, state, {
        isLoading: true
      })
    case RECEIVED_QUOTE_DETAILS:
      return Object.assign({}, state, {
        isLoading: false,
        hasErrors: false
      })
    case QUOTE_DETAILS_ERRORS:
      return Object.assign({}, state, {
        isLoading: false,
        hasErrors: true,
        errorStatus: action.payload
      })
    case UPDATE_CURRENT_STEP:
      return Object.assign({}, state, {
        currentStep: action.payload
      })
    case SET_REFERENCE_ID:
      return Object.assign({}, state, {
        refId: action.payload
      })
    case FORM_SUBMISSION_SUCCESS:
      return Object.assign({}, state, {
        currentStep: 2
      })
    default:
      return state
  }
}

export default appState
